module.exports = __webpack_public_path__ + "img/app-icon-2.b0c8dfc9.png";